// extracted by mini-css-extract-plugin
module.exports = {"headCell":"head_headCell__2IiL0","pTag":"head_pTag__21u-L"};